import React, { useEffect, useState, useCallback } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import "../../css/App.css";
import "../../css/color.css";
import _ from "lodash";
import TokenService from "../../service/TokenService";
import SriyanshCardHeader from "../../components/CardHeader";
import ExportToExcelCustomButton from "../../components/ExportToExcelButtonCustom";
//import ExporttoPDFButton from "../../components/ExporttoPDFButton";
import SearchTextField from "../../CustomComponant/SearchTextField";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable";
import ExportToPDFCustomButton from "../../components/ExportPDFfromTable.js";
import { DISPLAY_PAGE_SIZE } from "../../constants/constants.js";
function AccountsPendingList() {
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [srcinddata, setSrcinddata] = useState("");

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const [reportData, setReportData] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      try {
        //setPageLoader(true);
        const response = await apiClient.post("/pendingforaccount", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);

        const allDataResponse = await apiClient.post("/pendingforaccount", {
          uname: uname,
          limit: '0', // No limit
          offset: '0', // No offset
          srcinddata: '', // No search term for fetching all data
        });
      
        setReportData(allDataResponse.data)

        
      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      }finally
      {
        setPageLoader(false);
      }
    }, 300),
    [uname, currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [srcinddata, fetchData]);

  const handleRowClick = (row) => {
    // Handle row click action with the row data
    viewData(row.ponumber, row.billnumber);
    //  console.log('Row data:', row);
  };

  const viewData = (po, bill) => {
    navigate("accountentry", {
      state: {
        expponumber: po,
        expbillnumber: bill,
      },
    });
  };

  const columns = [
    "Shop",
    "ponumber",
    "POItemName",
    "billnumber",
    "billdate",
    "billpassingdate",
    "daydiff",
  ]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "PO Number",
    "Item Name",
    "Bill Number",
    "Bill Date",
    "Bill Passing Date",
    "Pending Days from Bill Passing",
  ];

  return (
    <div >
      {/* <SriyanshCardHeader Title="Account Receiving Pending List" /> */}

      <Card className="Formcard">

      <div className="input-groupHeading">
      Account Receiving Pending List

            </div>


        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}
          {currentPage === 1 ? (
            <SearchTextField
              label="PO Number"
              value={srcinddata}
              title="Enter PO Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

         {pageLoader? <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>: <ListDynamicTable
            columns={columns}
            columnNames={columnNames}
            data={returnData}
            totalRows={totalRows}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onRowClick={handleRowClick}
          />
}
          <div className="mb-3 mt-2 container col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportData}
              fileName={"Bill Sent to Account" } // + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel "
            />

<ExportToPDFCustomButton
              data={reportData}
              fileName={"Bill Sent to Account" } // + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF "
              pageHeader="Account Receiving Pending List"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default AccountsPendingList;
